import { useThemeCompanyCount } from '@terminal/react-query-hooks/themes/useThemeCompanyCount';
import { useTranslation } from 'react-i18next';

export interface ThemeSubtitleProps {
  themeId: string;
}

export const ThemeSubtitle = ({ themeId }: ThemeSubtitleProps) => {
  const { t } = useTranslation('widget');
  const companyCount = useThemeCompanyCount(themeId);

  return (
    <>
      {t('widget:themeOverview.investmentTheme')}
      {companyCount !== undefined && (
        <>
          {' · '}
          {t('widget:themeOverview.companiesCounter', {
            count: companyCount,
          })}
        </>
      )}
    </>
  );
};
